import { Dialog, useMediaQuery } from "@mui/material";
import { CustomBackdrop } from "../../pages/newBuyNode/components/NodeModal";
import cn from "classnames";
import CloseModalButton from "./components/CloseModalButton";

export const Modal = ({isOpened, onClose, children}) => {
  const sm = useMediaQuery("(max-width: 767px)");

  return (
    <Dialog
      scroll={!sm ? "body" : "paper"}
      onClose={onClose}
      open={isOpened}
      slots={{ backdrop: CustomBackdrop }}
      PaperProps={{
        sx: {
          mb: 0,
          mt: "auto",
          mx: "auto",
          boxShadow: "0px 0px 12px #00000029",
          borderRadius: "26px",
          borderBottomLeftRadius: { xs: 0, sm: "24px" },
          borderBottomRightRadius: { xs: 0, sm: "24px" },
          minHeight: "200px",
          overflowY: { xs: "auto", sm: "visible" },
          maxHeight: "100dvh",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          "-ms-overflow-style": "none",
          "scrollbar-width": "none",
        },
      }}
    >
      <div
        className={cn(
          "font-inter max-w-140 h-full bg-white shadow-smallShadow rounded-3xl dark:bg-[#1D1C2D]"
        )}
      >
        <div className="flex justify-between items-center md:items-start  py-4 px-6 md:px-8 md:py-6 border-b border-lightGrayBlue dark:border-darkSlateBlue">
          <h3 className="font-bold leading-9 text-xl md:text-2xl text-black dark:text-white">
						Buy Founder’s Node
          </h3>
          <CloseModalButton closeModal={onClose} />
        </div>

        {children}
      </div>
    </Dialog>
  );

};
